import { API } from '@/shared/api/modules';
import type {
  GetRevenueAnalysisForecastRequestDto,
  GetRevenueAnalysisRequestDto,
} from '@/shared/api/modules/facilities';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

/**
 * One request serves both metrics: the response carries revenue *and* the resident count behind
 * it per month, so switching Revenue ↔ Revenue per resident is a re-render, not a refetch.
 *
 * `keepPreviousData` keeps the chart on screen while the pager moves, instead of collapsing to a
 * spinner on every month step.
 */
export const getRevenueAnalysisQueryOptions = (
  params: GetRevenueAnalysisRequestDto
) =>
  queryOptions({
    queryKey: ['revenue-analysis', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getRevenueAnalysis(params, { signal }),
    placeholderData: keepPreviousData,
  });

export const getRevenueAnalysisForecastQueryOptions = (
  params: GetRevenueAnalysisForecastRequestDto
) =>
  queryOptions({
    queryKey: ['revenue-analysis-forecast', params],
    queryFn: async ({ signal }) =>
      await API.facilities.getRevenueAnalysisForecast(params, { signal }),
    placeholderData: keepPreviousData,
  });
